// TODO: There's probably no reason for anything except SearchResult to be in this file.
// Types should generally be defined where they're used or are most relevant, not dropped into
// a generic file.

import { LocationReference } from "#next/components/explorer/visuals/Map";

// Possible titles for ExplorerModal
export enum ModalHeaderTitle {
  Geographic = "Geographic References",
  Date = "Date References",
  Conversation = "Conversation",
  User = "User",
}

export enum RankingTabs {
  platform = "platform",
  username = "username",
  hashtags = "hashtags",
  links = "links",
  entity = "entity",
}

export enum GraphMode {
  platform = "platform",
  language = "language",
}

interface BaseSearchResult {
  _originalTimestamp: number; // TODO: Get rid of this and only have one timestamp
  conversation: string | null;
  dates: string[];
  engagement_rate: number | null;
  entities: string[];
  hashtags: string[] | null; // TODO: Remove | null and have empty array if there are no links?
  hateful: number;
  id: string;
  knnScore?: number;
  language_code: string;
  links: string[] | null; // TODO: Remove | null and have empty array if there are no links?
  locations: LocationReference[];
  media: string[];
  mediaIsBlocked: boolean; // TODO: Ideally we'd block individual reported media, but that requires schema changes.
  narratives?: {
    narrative: string;
    similarity: number;
  }[];
  negative: number;
  normalized_relevance: number;
  offensive: number;
  platform: string;
  platformFields: object;
  record_type: string;
  sentiment: number;
  text: string;
  timestamp: string; // formatted to ISO 8601
  translation: string | null;
  url: string | null;
  user_id: string | null;
  username: string | null;
  violent: number;
  occurrences?: number;
}

export interface FourChanSearchResult extends BaseSearchResult {
  platform: "4chan";
  platformFields: {
    board: string;
  };
}

export interface RedditSearchResult extends BaseSearchResult {
  platform: "Reddit";
  platformFields: {
    subreddit: string;
  };
}

export type SearchResult =
  | BaseSearchResult
  | FourChanSearchResult
  | RedditSearchResult;

export type SearchResultFields = keyof SearchResult;

export interface IMediaSearchResult {
  postId: string;
  knnScore: number;
  platform: string;
  s3Key: string;
  s3BucketName: string;
}

export interface SavedSearch {
  id: string;
  name: string;
  lastLoaded: string | null; // formatted to ISO 8601
  lastResultCount: number | null;
}
